<template>
  <div id="app">
    <!-- 语言切换按钮 - 右上角 -->
    <div class="language-switcher">
      <div class="lang-btn" :class="{ active: $i18n.locale === 'zh' }" @click="changeLang('zh')">
        中文
      </div>
      <div class="lang-divider"></div>
      <div class="lang-btn" :class="{ active: $i18n.locale === 'en' }" @click="changeLang('en')">
        EN
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import global from './config/index'

export default {
    name: "App",
    components: {
    },
    data() {
        return {
            isMobile: false, // 是否是移动端
        }
    },
    mounted() {
        this._initData();
    },
    methods: {
        // 切换语言 - 不保存到 localStorage
        changeLang(lang) {
            this.$i18n.locale = lang
            // localStorage.setItem('locale', lang) // 已删除，不再保存
        },
        // 判断是否为移动端
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        _initData() {
/*                if (this._isMobile()) {
                    // 是移动端，则跳转到移动端首页
                    this.isMobile = true;
                    if (global.getLn()) {
                        this.$router.replace('/mobile/map');
                    } else {
                       this.$router.replace('/mobile/index');
                    }
                } else {
                  // 是pc，跳转到/system/portal页
                  this.isMobile = false;
                  console.log('global.getLn========APP', global.getLn())
                  this.$router.push('/')
                }*/
        }
    }
};
</script>

<style lang="less">
    #app {
        font-family: "Microsoft YaHei", "微软雅黑";
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>

<style scoped>
/* 语言切换器 - 右上角悬浮 */
.language-switcher {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 6px 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.language-switcher:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}

.lang-btn {
  padding: 6px 14px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  border-radius: 16px;
  transition: all 0.3s ease;
  user-select: none;
}

.lang-btn:hover {
  color: #00a0e9;
  background: rgba(0, 160, 233, 0.1);
}

.lang-btn.active {
  color: #fff;
  background: linear-gradient(135deg, #00a0e9 0%, #0080c9 100%);
  box-shadow: 0 2px 8px rgba(0, 160, 233, 0.3);
}

.lang-divider {
  width: 1px;
  height: 16px;
  background: #e0e0e0;
  margin: 0 4px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .language-switcher {
    top: 10px;
    right: 10px;
    padding: 4px 6px;
    border-radius: 16px;
  }
  
  .lang-btn {
    padding: 4px 10px;
    font-size: 12px;
  }
}
</style>

<style>
    .el-menu.el-menu--horizontal {
        border-bottom: 0 none !important;
    }

    .el-menu--horizontal > .el-menu-item {
        height: 32px !important;
        line-height: 24px !important;
        font-size: 16px;
        margin-top: 14px !important;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
        background-color: #00a0e9 !important;
        border-radius: 16px;
    }

    .el-collapse-item__header {
        background-color: #00479d !important;
        color: #fff !important;
        font-size: 14px !important;
        border-bottom: 1px solid #1d2088 !important;
    }

    .el-collapse-item__wrap {
        background-color: unset !important;
        border-bottom: 0 none !important;
    }

    .el-collapse {
        border-bottom: 0 none !important;
    }

    .leftSlideBox .el-form-item__label {
        color: #fff !important;
        font-size: 12px;
        padding-right: 0;
    }

    .leftSlideBox .el-form-item {
        margin-bottom: 0;
    }

    .leftSlideBox .el-collapse-item__content {
        padding-bottom: 0;
    }

    .ivu-checkbox-wrapper {
        font-size: 12px !important;
        margin-bottom: 5px;
    }
    .el-popup-parent--hidden {
      padding-right: 0 !important;
    }
</style>